import { Text, TextProps, useColorModeValue } from "@chakra-ui/react";
import React from "react";

export const TextGray: React.FC<TextProps> = ({ ...props }) => {
  const containerColor = useColorModeValue("gray.500", "gray.400");

  return <Text color={containerColor} {...props}></Text>;
};
